import { useEffect, useState } from "react";
import { getCardOnFileStatus } from "app/utils/request/scheduling/cardOnFileStatus";

/**
 * Returns whether the given paying athlete has a saved card on file at the
 * given coach's connected Stripe account. Returns `null` while the lookup is
 * in flight or when prerequisites are missing — callers should treat `null`
 * as "unknown" (do not yet hide the option).
 */
export default function useCardOnFileStatus(
  athleteId: string | undefined,
  coachExternalId: string | undefined,
): boolean | null {
  const [hasCard, setHasCard] = useState<boolean | null>(null);

  useEffect(() => {
    if (!athleteId || !coachExternalId) {
      setHasCard(null);
      return undefined;
    }

    let cancelled = false;
    setHasCard(null);

    getCardOnFileStatus(athleteId, coachExternalId)
      .then((result) => {
        if (!cancelled) { setHasCard(result); }
      })
      .catch((err) => {
        console.error("Error fetching card-on-file status:", err);
        if (!cancelled) { setHasCard(null); }
      });

    return () => { cancelled = true; };
  }, [athleteId, coachExternalId]);

  return hasCard;
}
